module.exports = __webpack_public_path__ + "static/img/window_bgm.2e3c9a94.jpg";